/**
 * Proposte famiglia: chip filtro landing (match in DynamicPropostePubblicheSection).
 * La categoria Strapi non è più nel form admin: viene dedotta al salvataggio da tipo esperienza.
 */

/** Chip sezione proposte landing famiglie. */
export const FAMILY_PROPOSTE_FILTER_CHIPS = [
  { key: 'all', label: 'Tutte', keywords: [] },
  {
    key: 'outdoor',
    label: 'Outdoor',
    matchExperienceTypes: ['outdoor'],
    matchCategories: ['gita', 'esperienza'],
    keywords: [
      'outdoor',
      'escursion',
      'passegg',
      'natura',
      'munlab',
      'pic-nic',
      'tesoro',
      'parco',
    ],
  },
  {
    key: 'lab',
    label: 'Laboratori',
    matchExperienceTypes: ['creativo'],
    matchCategories: ['laboratorio', 'corso'],
    keywords: ['laborator', 'arte', 'manual', 'argilla', 'legno', 'stagional'],
  },
  {
    key: 'gioco',
    label: 'Gioco',
    matchExperienceTypes: ['gioco'],
    matchCategories: ['torneo'],
    keywords: ['tavolo', 'torneo', 'cooperativ', 'ludic'],
  },
  {
    key: 'eventi',
    label: 'Eventi',
    matchCategories: ['evento', 'rassegna'],
    keywords: ['festa', 'tema', 'spettacol', 'community'],
  },
];
